<script>
    import {Link} from "svelte-routing";
    import {num_word} from "../lib/Common.svelte";
    import {_} from '../lib/i18n';

    export let params;
    let path = '';
    $: path = (params && params.path) ? params.path : '';

    export let identity;
    export let maxAnalyzes = 0;

    let show = true;

    function hide() {
        show = false;
        try {
            identity.changeKeyValue('showAnalyzesLimitWarning', false);
            identity.showAnalyzesLimitWarning = false;
            identity = identity;
        } catch (err) {
            console.error(err);
        }
    }
</script>


<section class="adding-limit-block system-info system-info_yellow">
    <div class="adding-limit-block__title-wrapper system-info__title-wrapper">
        <div class="adding-limit-block__title-icon system-info__title-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.5 15.8337V15.0003C2.5 13.1594 3.99238 11.667 5.83333 11.667H9.16667C11.0076 11.667 12.5 13.1594 12.5 15.0003V15.8337M12.5 9.16699C13.8807 9.16699 15 8.0477 15 6.66699C15 5.28628 13.8807 4.16699 12.5 4.16699M17.5 15.8337V15.0003C17.5 13.1594 16.0076 11.667 14.1667 11.667H13.75M10 6.66699C10 8.0477 8.88071 9.16699 7.5 9.16699C6.11929 9.16699 5 8.0477 5 6.66699C5 5.28628 6.11929 4.16699 7.5 4.16699C8.88071 4.16699 10 5.28628 10 6.66699Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
        </div>
        <h3 class="adding-limit-block__title-text system-info__title-text">Добавление новой цели</h3>
    </div>
    <p class="adding-limit-block__text system-info__text">
        {$_('analyzeLimitAlert.disclaimer', {
            values: {
                limit: (maxAnalyzes > 1 ? 3 : 1),
                target_word: num_word((maxAnalyzes > 1 ? 3 : 1), [
                    $_('analyzeLimitAlert.targetWordForm1'),
                    $_('analyzeLimitAlert.targetWordForm2'),
                    $_('analyzeLimitAlert.targetWordForm3')
                ]),
            }
        })}
    </p>
    <div class="adding-limit-block__controls-wrapper system-info__controls-wrapper">
        <Link to={`${path}/dashboard/settings`}
              class="adding-limit-block__btn button button_ghost system-info__controls-btn system-info__controls-btn_main">
            {$_('analyzeLimitAlert.settingsLabel')}</Link>

        <button class="adding-limit-block__btn button button_textual system-info__controls-btn system-info__controls-btn_secondary"
            on:click={hide}>
            {$_('analyzeLimitAlert.hideLabel')}
        </button>
    </div>
</section>